import { indexData } from '@/mocks/home';

const categoryColors: Record<string, string> = {
  '热血': 'oklch(var(--accent-500))',
  '恋爱': 'oklch(var(--primary-500))',
  '悬疑': 'oklch(var(--secondary-500))',
  '仙侠': 'oklch(var(--primary-600))',
  '搞笑': 'oklch(var(--accent-600))',
  '都市': 'oklch(var(--secondary-600))',
  '奇幻': 'oklch(var(--accent-500))',
  '校园': 'oklch(var(--primary-500))',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">主题索引</h2>
          <p className="text-sm text-foreground-500 mt-2">按分类快速找到你想看的漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group p-5 rounded-lg cursor-pointer transition-all duration-200 border"
              style={{
                backgroundColor: 'oklch(var(--background-50))',
                borderColor: 'oklch(var(--background-200))',
              }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className="w-2 h-2 rounded-full flex-shrink-0"
                  style={{ backgroundColor: categoryColors[item.category] || 'oklch(var(--primary-500))' }}
                ></div>
                <span className="text-xs font-medium text-foreground-500">{item.category}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:opacity-80 transition-opacity">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500">{item.count.toLocaleString()} 部作品</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}